<template>
  <main class="main mb2 main--full-height">
    <div class="group">
      <div class="grid grid--auth">
        <div class="grid__item grid__item--4 hide-below-medium" />
        <div class="grid__item grid__item--2">
          <ui-auth
            id="confirm"
          />
        </div>
      </div>
    </div>
  </main>
</template>

<script>
// Ui
import UiAuth from 'components/Auth';

// Export
export default {
  name: 'view-confirm',

  // Components
  components: {
    UiAuth,
  },
};
</script>



// WEBPACK FOOTER //
// Confirm.vue?3d9112da